<template>
  <v-alert color="primary" text class="pl-8 mb-8" max-width="600">
    <ressource code="domicile_professionnel" />
    <div class="mt-3">
      {{ domicileProfessionnel }}
    </div>
  </v-alert>
</template>

<script>
export default {
  props: {
    sas: Object
  },
  computed: {
    domicileProfessionnel() {
      if (this.sas.sasInscriptionTableau.lieuDeTravailPrincipal) {
        const sasAdresse = this.sas.sasAdressesProfessionnelles.find((x) => x.id === this.sas.sasInscriptionTableau.lieuDeTravailPrincipal)
        if (sasAdresse && !sasAdresse?.inactif) {
          return [sasAdresse.organisation, sasAdresse.rue1, sasAdresse.codePostal].filter(s => s).join(" - ")
        }
      }
      return `${this.sas.identification.adresse}, ${this.sas.identification.ville}, ${this.sas.identification.codePostal}`
    }
  }
}
</script>